import React from 'react';
import PropTypes from 'prop-types';

import IconCheck from '@spothero/icons/check';
import {Box, Button, Heading, Icon, Image, useTheme} from '@spothero/ui';

import {
    noEventsMapStyleProps,
    noEventsInfoStyleProps,
    noEventsIconStyleProps,
    noEventsTitleStyleProps,
    noEventsButtonStyleProps,
    noEventsInfoListStyleProps,
    noEventsInfoItemStyleProps,
    noEventsMapImageStyleProps,
    noEventsContainerStyleProps,
} from './NoEventsStyleProps';

const NoEvents = ({destinationId, trackingLink}) => {
    const {
        partnerWidgetStyles: {noEventsStyles: customNoEventStyles},
    } = useTheme();

    return (
        <Box {...noEventsContainerStyleProps} {...customNoEventStyles}>
            <Box {...noEventsInfoStyleProps}>
                <Heading as="h3" {...noEventsTitleStyleProps}>
                    Book Parking with SpotHero
                </Heading>
                <Box {...noEventsInfoListStyleProps}>
                    <Box {...noEventsInfoItemStyleProps}>
                        <Icon as={IconCheck} {...noEventsIconStyleProps} />
                        Fast, prepaid parking reservation
                    </Box>
                    <Box {...noEventsInfoItemStyleProps}>
                        <Icon as={IconCheck} {...noEventsIconStyleProps} />
                        Easily edit or extend your parking
                    </Box>
                    <Box {...noEventsInfoItemStyleProps}>
                        <Icon as={IconCheck} {...noEventsIconStyleProps} />
                        Guaranteed by SpotHero
                    </Box>
                </Box>

                <Button
                    as="a"
                    target="_parent"
                    href={`${trackingLink}&kind=destination&id=${destinationId}`}
                    {...noEventsButtonStyleProps}
                >
                    Book Nearby Parking
                </Button>
            </Box>
            <Box {...noEventsMapStyleProps}>
                <Image
                    alt="Parking Map Illustration"
                    src="https://res.cloudinary.com/spothero/image/upload/v1630676535/front-end/partner-widget-placeholder-map.png"
                    {...noEventsMapImageStyleProps}
                />
            </Box>
        </Box>
    );
};

NoEvents.propTypes = {
    trackingLink: PropTypes.string,
    destinationId: PropTypes.number,
};

export default NoEvents;
